<template>
    <div class="loading-overlay" v-if="this.loading">
        <loader :size="size"></loader>
    </div>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            size: {
                type: Number,
                default: 80,
            }
        }
    };
</script>

<style lang="scss" scoped>
.loading-overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, .8);
    z-index: 99998;
}
</style>
